import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'
import {ReactElement} from "react";

type BufferListProps<D> = {
    horizontal?: boolean,
    data: readonly D[],
    render: (item: D, i: number) => ReactElement,
}

const BufferList = <D, >(
    props: BufferListProps<D>
) => {
    const {BufferList: BaseBufferList} = usePrimitives()

    if (!BaseBufferList) {
        throw new NonExistentPrimitiveError('BufferList')
    }

    return <BaseBufferList<D>
        {...props}
    />
}

const BufferListWithTheme = <D,>(props: BufferListProps<D> & UnnormalizedStyleProps) => <WithTheme
    {...props}
    identifier='buffer_list'
    Component={BufferList}
/>

export default BufferListWithTheme
